// extracted by mini-css-extract-plugin
module.exports = {"skill-container":"skill_skill-container__10hAF","skill-level":"skill_skill-level__3fpU9"};